import {View} from 'backbone';
import {withMainLoader} from '@sinclair-digital/stl-common/src/sinclair/sinclair.ajax';
import propertyListTemplate from 'templates/properties/propertyListTemplate.hbs';
import PropertyListCollection from 'collections/properties/propertyListCollection';
import {all, filter, map, pipe} from 'ramda';
import {bindAllMethods} from '@sinclair-digital/stl-common/src/backboneHelpers';

export const selectors = {
    searchBtn: '#property-search-btn',
    searchClearBtn: '#property-search-clear-btn',
    searchInput: '#property-search-input',
    propertyCard: '.js-sda-PropertyCard',
};

export default View.extend({
    debuggingName: 'Property List View',
    el: '#admin-main',
    navId: 'admin-properties-tab',
    sdaPageTitle: 'properties',
    template: propertyListTemplate,
    events: {
        [`keyup ${selectors.searchInput}`]: '_searchHandler',
        [`click ${selectors.searchClearBtn}`]: '_clearSearchHandler',
    },
    initialize() {
        bindAllMethods(this);
        this.collection = new PropertyListCollection();
        this.collection.fetch(withMainLoader).then(this.render);
    },
    render() {
        this.$el.html(this.template(this.collection.toJSON())).sdaInitWidgets();
        this.$(selectors.searchInput).focus();

        return this;
    },
    _searchHandler() {
        const val = this.$(selectors.searchInput)
            .val()
            .toLowerCase();
        const filterFields = ['search-name', 'search-url', 'search-callletters'];
        this.$(selectors.propertyCard).attr('style', '');

        if (val.length) {
            this.$(selectors.searchBtn).hide();
            this.$(selectors.searchClearBtn).show();
            this.$('.sda-card')
                .filter((__, el) => {
                    const $this = this.$(el);
                    return pipe(
                        map(key => $this.data(key)),
                        filter(exists => exists),
                        map(field => field.toString().toLowerCase()),
                        all(field => !field.includes(val)),
                    )(filterFields);
                })
                .attr('style', 'display: none;');
        } else {
            this.$(selectors.searchBtn).show();
            this.$(selectors.searchClearBtn).hide();
        }
    },
    _clearSearchHandler() {
        this.$(selectors.propertyCard).attr('style', '');
        this.$(selectors.searchInput).val('');
        this.$(selectors.searchBtn).show();
        this.$(selectors.searchClearBtn).hide();
    },
});
